let serverTimeCache: Date | null = null;

/** API 응답 Date 헤더로 서버 시각 캐시 갱신 */
export function setServerTimeFromDateHeader(
  dateHeader: string | undefined,
): void {
  if (!dateHeader) return;
  const parsed = new Date(dateHeader);
  if (!Number.isNaN(parsed.getTime())) serverTimeCache = parsed;
}

/** 서버에서 받은 시각. 한 번도 API가 없으면 로컬 시각 */
export function getServerTime(): Date {
  return serverTimeCache ?? new Date();
}
